import { createContext } from 'react';
import type { SiteAuthRuntime, SiteUserSession } from '../types';

export interface SiteAuthContextValue {
  session: SiteUserSession | null;
  isAuthenticated: boolean;
  isInitializing: boolean;
  runtime: SiteAuthRuntime | null;
  runtimeError: string | null;
  signIn: (email: string, password: string) => Promise<SiteUserSession>;
  signUp: (input: {
    email: string;
    password: string;
    name?: string;
    role: 'vendor' | 'resource_vendor' | 'adult_model' | 'parent' | 'donor';
  }) => Promise<SiteUserSession>;
  signOut: () => void;
  refreshSession: () => Promise<SiteUserSession | null>;
  changePassword: (currentPassword: string, newPassword: string) => Promise<void>;
}

export const SiteAuthContext = createContext<SiteAuthContextValue | null>(null);
